/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetStartEventMarker {
  width?: number,
  height?: number,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for start(origin) of the trip
 *
 * ```typescript
 *  import {getAssetStartEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetStartEventMarker({fillColor, width, height}),
 *    width  : width,
 *    height : height
 * }
 * ```
 */
export const getAssetStartEventMarker = ({
  fillColor = dlsColor('grey4'),
  width = 18,
  height = 18
}: AssetStartEventMarker) => {
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='9' cy='9' r='8' fill='white' stroke='white' stroke-width='2'/>
      <circle cx='9' cy='9' r='5' fill='white' stroke='${fillColor}' stroke-width='4'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetStartEventMarker;
